/**
 * Represents pin coordinates for specific positions.
 *
 * @typedef {Object} PinCoordinates
 * @property {string} x - The x-coordinate value.
 * @property {string} y - The y-coordinate value.
 */
/**
 * Object containing pin coordinates for 'left', 'middle', and 'right' positions.
 *
 * @type {Record<'left' | 'middle' | 'right', PinCoordinates>}
 */
export const pinCordinates = {
    /**
     * Coordinates for the 'left' position.
     * @type {PinCoordinates}
     */
    left: { x: '10px', y: '0%' },
    /**
     * Coordinates for the 'middle' position.
     * @type {PinCoordinates}
     */
    middle: { x: '50%', y: '0%' },
    /**
     * Coordinates for the 'right' position.
     * @type {PinCoordinates}
     */
    right: { x: '99%', y: '0%' },
};
/**
 * The commenting thread list cord is initially placed at 140px from the top.
 * This value indicated how far the draggable item can move from original position.
 */
export const DRAGGABLE_BOUNDS = { top: -140 };
export const setSeen = (threadId, status) => {
    var _a;
    // The current cord types (0.0.47) for ICordThreadSDK don't include setSeen, but the functionality of setSeen works fine in this version. Therefore, I'm extending the type to include setSeen. This extension can be removed once we update to the latest version
    const thread = (_a = window.CordSDK) === null || _a === void 0 ? void 0 : _a.thread;
    // Executing this function updates the thread's unread status to the read status.
    thread === null || thread === void 0 ? void 0 : thread.setSeen(threadId, status);
};
//# sourceMappingURL=wrap-cord-utlis.js.map